function mergeDimData(list, nextDim, mainDim='MGT_ORG_CODE', nextVal='indexValue') {
    let resList = [];
    for(let i=0; i<list.length; i++) {
        let item = list[i];
        let resItem = getItem(resList, mainDim, item[mainDim]);
        if (resItem) {
            let indexObj = {};
            indexObj[nextDim] = item[nextDim];
            indexObj[nextVal] = item[nextVal];
            resItem.indexList.push(indexObj);
        } else {
            let newItem = {};
            newItem[mainDim] = item[mainDim];
            newItem.indexList = [];
            let indexObj = {};
            indexObj[nextDim] = item[nextDim];
            indexObj[nextVal] = item[nextVal];
            newItem.indexList.push(indexObj);
            resList.push(newItem);
        }
    }
    return resList;
}

function getItem(list, key, val) {
    for(let i=0; i<list.length; i++) {
        let item = list[i];
        if (item[key] == val) {
            return item;
        }
    }
    return null;
}

function getAllVals(list, key = 'MGT_ORG_NAME') {
    let resList = [];
    for(let i=0; i<list.length; i++) {
        let item = list[i];
        let resItem = resList.indexOf(item[key]);
        if (resItem < 0) {
            resList.push(item[key]);
        }
    }
    return resList;
}

function getAllOrgNames(list, flag) {
    let resList = getAllVals(list, 'MGT_ORG_NAME');
    if (flag) {
        for (let i=0; i<resList.length; i++) {
            let orgName = resList[i];
            resList[i] = replaceOrgName(orgName);
        }
    }
    return resList;
}
// let arr = [
//     {
//         "MGT_ORG_CODE": "32401",
//         "MGT_ORG_NAME": "南京供电所",
//         "IMPT_LV": "01",
//         "indexValue": 4
//     },
//     {
//         "MGT_ORG_CODE": "32401",
//         "MGT_ORG_NAME": "南京供电所",
//         "IMPT_LV": "02",
//         "indexValue": 2
//     },
//     {
//         "MGT_ORG_CODE": "3240109",
//         "MGT_ORG_NAME": "江北公司浦口供电服务中心",
//         "IMPT_LV": "02",
//         "indexValue": 1
//     },
//     {
//         "MGT_ORG_CODE": "3240110",
//         "MGT_ORG_NAME": "南京市江宁区供电所",
//         "IMPT_LV": "01",
//         "indexValue": 2
//     }
// ];
// let result = getAllOrgNames(arr, true);
// console.log(JSON.stringify(result));

/**
 * 供电单位截取方法
 * 截取规则：‘电力公司’,'供电公司','供电所'
  */
function replaceOrgName(orgName, substr, repstr='') {
    let result = orgName;
    if (substr && substr.length > 0) {
        result = result.replace(substr, repstr);
    } else {
        let subarr = ['电力公司','供电公司','供电所','供电服务中心'];
        for (let i=0; i<subarr.length; i++) {
            substr = subarr[i];
            result = result.replace(substr, repstr);
        }
    }
    return result;
}

//标准代码转码方法
function getCodeClsName(codeList, codeClsVal) {
    for (let i=0; i<codeList.length; i++) {
        let item = codeList[i];
        if (item.codeClsVal == codeClsVal) {
            return item.codeClsValName;
        }
    }
    return null;
}

function getCodeClsVals(codeList) {
    let vals = [];
    for (let i=0; i<codeList.length; i++) {
        let item = codeList[i];
        vals.push(item.codeClsVal);
    }
    return vals;
}

function getCodeClsNames(codeList) {
    let names = [];
    for (let i=0; i<codeList.length; i++) {
        let item = codeList[i];
        names.push(item.codeClsValName);
    }
    return names;
}

function getMonths(year) {
    let curYear = window.moment().get('year');
    let months = [];
    if (year && curYear != year) {
        for (let i=1; i<=12; i++) {
            months.push(year + "" + ((i>9)?i:("0"+i)));
        }
    } else {
        let curMonth = window.moment().get('month');
        for (let i=1; i<=curMonth; i++) {
            months.push(year + "" + ((i>9)?i:("0"+i)));
        }
    }
    return months;
}

function getDays(date) {
    let curDate = window.moment().format("yyyyMM");
    let days = [];
    if (date && curDate != date) {
        let dd = window.moment(date,'YYYY-MM').daysInMonth()
        for (let i=1; i<=dd; i++) {
            days.push(date + "" + ((i>9)?i:("0"+i)));
        }
    } else {
        date = window.moment().format("yyyyMM");
        let curDay = window.moment().get('date');
        for (let i=1; i<=curDay; i++) {
            days.push(date + "" + ((i>9)?i:("0"+i)));
        }
    }
    return days;
}

export default {
    getDays,
    getMonths,
    getItem,
    getAllVals,
    getAllOrgNames,
    mergeDimData,
    replaceOrgName,
    getCodeClsName,
    getCodeClsVals,
    getCodeClsNames
}
